import React, { useState } from 'react'
import './navitem.css'

const Navitem = ({ children, icon, link }) => {
  const [open, setOpen] = useState(false)
  const handleClick = () => {
    setOpen(!open)
  }
  return (
    <li className="nav-item">
      <a href={link} className="icon-button" onClick={handleClick}>
        <img src={icon} alt={icon} />
      </a>
      {open && children}
    </li>
  )
}

export default Navitem
